import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { getTransactionSideOptionLabels } from 'bundles/apex/deals/helpers/labels';
import { setRentEscalation } from 'bundles/apex/deals/form/store/deal/actions';
import { BUY_SIDE, SELL_SIDE } from 'bundles/backoffice/vouchers/helpers/transaction_side_details';

import RentEscalationModal from 'components/lease_structure/form/rent_escalation_modal';

export function LeaseStructureCreateModal({ deal, features, setRentEscalation, show, onCancel, onCreate }) {
  function handleSumbit(escalation) {
    setRentEscalation(escalation);
    onCreate();
  }

  const transactionSideOptions = getTransactionSideOptionLabels(deal.dealType);
  const commissionProps = { commissionMode: deal.commissionMode };

  if (deal.hasTransactionSides) {
    const buySideDetails = deal.transactionSideDetails.find(detail => detail.transactionSide === BUY_SIDE);
    const sellSideDetails = deal.transactionSideDetails.find(detail => detail.transactionSide === SELL_SIDE);
    commissionProps.buySideCommissionPercent = buySideDetails.grossPercent;
    commissionProps.buySideCommissionRate = buySideDetails.grossRate;
    commissionProps.sellSideCommissionPercent = sellSideDetails.grossPercent;
    commissionProps.sellSideCommissionRate = sellSideDetails.grossRate;
  } else {
    commissionProps.commissionPercent = deal.grossCommissionPercent;
    commissionProps.commissionRate = deal.commissionRate;
  }

  return (
    <RentEscalationModal
      duration={deal.leaseTerm}
      durationUnits={deal.leaseTermUnits}
      enableOperatingExpenses={features.operatingExpenses}
      headerLabel="Generate Rent Schedule"
      initialLeaseRate={deal.leaseRate}
      leaseRateUnits={deal.leaseRateUnits}
      saveButtonLabel="Generate Schedule"
      show={show}
      spaceSizeUnits={deal.spaceSizeUnits}
      transactionSideOptions={transactionSideOptions}
      useTransactionSideValues={!!deal.hasTransactionSides}
      onClose={onCancel}
      onSubmit={handleSumbit}
      {...commissionProps}
    />
  );
}

LeaseStructureCreateModal.propTypes = {
  deal: PropTypes.shape({
    commissionMode: PropTypes.string,
    commissionRate: PropTypes.number,
    grossCommissionPercent: PropTypes.number,
    hasTransactionSides: PropTypes.bool,
    includeOperatingExpenses: PropTypes.bool,
    leaseRate: PropTypes.number,
    leaseRateUnits: PropTypes.string,
    leaseTerm: PropTypes.number,
    leaseTermUnits: PropTypes.string,
  }).isRequired,
  features: PropTypes.shape({
    operatingExpenses: PropTypes.bool,
  }).isRequired,
  setRentEscalation: PropTypes.func.isRequired,
  show: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  deal: state.deal,
  features: state.features,
});

const mapDispatchToProps = {
  setRentEscalation,
};

export default connect(mapStateToProps, mapDispatchToProps)(LeaseStructureCreateModal);
